export default {"src":"/_next/static/media/2.9fe3e9ba.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};